import React, { useState, useEffect } from 'react';
import './App.css';
import ApiService from './services/api';

function App() {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [visitorCount, setVisitorCount] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newItem, setNewItem] = useState({ name: '', description: '' });

  useEffect(() => {
    // Update time every second
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    // Simulate visitor count
    setVisitorCount(Math.floor(Math.random() * 1000) + 100);

    // Load data from API
    loadData();

    return () => clearInterval(timer);
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const result = await ApiService.getData();
      if (result.success) {
        setData(result.data);
      }
    } catch (error) {
      console.error('Failed to load data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveData = async (e) => {
    e.preventDefault();
    if (!newItem.name || !newItem.description) return;

    setLoading(true);
    try {
      const result = await ApiService.saveData(newItem);
      if (result.success) {
        setNewItem({ name: '', description: '' });
        loadData(); // Reload data
      }
    } catch (error) {
      console.error('Failed to save data:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Welcome to My React Website!</h1>
        <p>A modern, responsive website built with React.js</p>
      </header>

      <main className="App-main">
        <section className="hero">
          <h2>🚀 React.js Website</h2>
          <p>This is a sample React website that you can customize and deploy!</p>
        </section>

        <section className="features">
          <h3>Features</h3>
          <div className="feature-grid">
            <div className="feature-card">
              <h4>⚡ Fast</h4>
              <p>Built with React for optimal performance</p>
            </div>
            <div className="feature-card">
              <h4>📱 Responsive</h4>
              <p>Works perfectly on all devices</p>
            </div>
            <div className="feature-card">
              <h4>🎨 Modern</h4>
              <p>Beautiful, modern design</p>
            </div>
            <div className="feature-card">
              <h4>🔧 Customizable</h4>
              <p>Easy to modify and extend</p>
            </div>
          </div>
        </section>

        <section className="stats">
          <h3>Live Stats</h3>
          <div className="stats-grid">
            <div className="stat-item">
              <span className="stat-number">{visitorCount}</span>
              <span className="stat-label">Visitors Today</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{currentTime.toLocaleTimeString()}</span>
              <span className="stat-label">Current Time</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">100%</span>
              <span className="stat-label">Uptime</span>
            </div>
          </div>
        </section>

        <section className="data-section">
          <h3>Data Management</h3>
          <p>This section demonstrates integration with AWS DynamoDB via API Gateway</p>
          
          <div className="data-form">
            <h4>Add New Item</h4>
            <form onSubmit={handleSaveData}>
              <input
                type="text"
                placeholder="Item name"
                value={newItem.name}
                onChange={(e) => setNewItem({...newItem, name: e.target.value})}
                required
              />
              <input
                type="text"
                placeholder="Description"
                value={newItem.description}
                onChange={(e) => setNewItem({...newItem, description: e.target.value})}
                required
              />
              <button type="submit" disabled={loading}>
                {loading ? 'Saving...' : 'Save Item'}
              </button>
            </form>
          </div>

          <div className="data-list">
            <h4>Stored Items ({data.length})</h4>
            {loading ? (
              <p>Loading...</p>
            ) : (
              <div className="items-grid">
                {data.map((item) => (
                  <div key={item.id} className="item-card">
                    <h5>{item.name}</h5>
                    <p>{item.description}</p>
                    <small>Created: {new Date(item.createdAt).toLocaleDateString()}</small>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>

        <section className="cta">
          <h3>Ready to Get Started?</h3>
          <p>This website is ready to be customized and deployed!</p>
          <button className="cta-button">Learn More</button>
        </section>
      </main>

      <footer className="App-footer">
        <p>&copy; 2024 My React Website. Built with ❤️ using React.js</p>
      </footer>
    </div>
  );
}

export default App;
